import { useTranslation } from "react-i18next";
import { Badge, Checkbox, Grid, Text } from "@mantine/core";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { FormItem } from "../../../../FormItem";

export interface AssignmentOutcomeDetailProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentOutcomeDetail = ({ campaign }: AssignmentOutcomeDetailProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <Grid mb="md">
                <Grid.Col xs={12} sm={6} md={4}>
                    <Checkbox
                        color="gray"
                        label={t("campaign_outcome_includeimages")}
                        checked={campaign?.outcome?.includeImages}
                        onChange={() => {}}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={4}>
                    <Checkbox
                        color="gray"
                        label={t("campaign_outcome_includevideo")}
                        checked={campaign?.outcome?.includeVideo}
                        onChange={() => {}}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={4}>
                    <Checkbox
                        color="gray"
                        label={t("campaign_outcome_includesocialposts")}
                        checked={campaign?.outcome?.includeSocialPosts}
                        onChange={() => {}}
                    />
                </Grid.Col>
            </Grid>
            <Grid>
                <Grid.Col xs={12} sm={6} md={4}>
                    <FormItem label={t("campaign_outcome_hashtags")}>
                        {!campaign?.outcome?.hashtags?.length && <Text color="dimmed">-</Text>}
                        {(campaign?.outcome?.hashtags || []).map((hashtag, index) => (
                            <Badge key={`${index}${hashtag}`}>{hashtag}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={4}>
                    <FormItem label={t("campaign_outcome_fbmentions")}>
                        {!campaign?.outcome?.fbMentions?.length && <Text color="dimmed">-</Text>}
                        {(campaign?.outcome?.fbMentions || []).map((mention, index) => (
                            <Badge key={`${index}${mention}`}>{mention}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={4}>
                    <FormItem label={t("campaign_outcome_igmentions")}>
                        {!campaign?.outcome?.igMentions?.length && <Text color="dimmed">-</Text>}
                        {(campaign?.outcome?.igMentions || []).map((mention, index) => (
                            <Badge key={`${index}${mention}`}>{mention}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
            </Grid>
        </>
    );
};
